/**
 * P3-PROPOSAL — Barlow Condensed Bold advance widths em/1000 (auto-generated;
 * DO NOT EDIT). F4 title face, 2026-10-22.
 */
export const BARLOW_COND_W: Record<string, Record<string, number>> = {
  "bold": {
    "32": 200.0,
    "33": 279.0,
    "34": 346.0,
    "35": 616.0,
    "36": 444.0,
    "37": 766.0,
    "38": 603.0,
    "39": 170.0,
    "40": 311.0,
    "41": 311.0,
    "42": 361.0,
    "43": 438.0,
    "44": 211.0,
    "45": 331.0,
    "46": 223.0,
    "47": 415.0,
    "48": 453.0,
    "49": 284.0,
    "50": 438.0,
    "51": 436.0,
    "52": 484.0,
    "53": 439.0,
    "54": 440.0,
    "55": 407.0,
    "56": 440.0,
    "57": 435.0,
    "58": 275.0,
    "59": 232.0,
    "60": 438.0,
    "61": 438.0,
    "62": 438.0,
    "63": 437.0,
    "64": 759.0,
    "65": 482.0,
    "66": 470.0,
    "67": 464.0,
    "68": 476.0,
    "69": 438.0,
    "70": 421.0,
    "71": 467.0,
    "72": 480.0,
    "73": 230.0,
    "74": 452.0,
    "75": 491.0,
    "76": 426.0,
    "77": 548.0,
    "78": 514.0,
    "79": 473.0,
    "80": 465.0,
    "81": 461.0,
    "82": 471.0,
    "83": 444.0,
    "84": 468.0,
    "85": 479.0,
    "86": 488.0,
    "87": 689.0,
    "88": 475.0,
    "89": 474.0,
    "90": 412.0,
    "91": 345.0,
    "92": 415.0,
    "93": 345.0,
    "94": 422.0,
    "95": 421.0,
    "96": 220.0,
    "97": 446.0,
    "98": 445.0,
    "99": 434.0,
    "100": 445.0,
    "101": 436.0,
    "102": 298.0,
    "103": 441.0,
    "104": 447.0,
    "105": 219.0,
    "106": 217.0,
    "107": 449.0,
    "108": 209.0,
    "109": 675.0,
    "110": 447.0,
    "111": 442.0,
    "112": 448.0,
    "113": 448.0,
    "114": 324.0,
    "115": 412.0,
    "116": 291.0,
    "117": 447.0,
    "118": 436.0,
    "119": 613.0,
    "120": 439.0,
    "121": 423.0,
    "122": 373.0,
    "123": 344.0,
    "124": 186.0,
    "125": 344.0,
    "126": 490.0
  },
};
